import React from 'react'
import icon360 from '../../../assets/images/icon-360.svg'
import iconRespirable from '../../../assets/images/icon-respirable.png'
import iconNoche from '../../../assets/images/icon-noche.svg'
import iconTallas from '../../../assets/images/icon-tallas.svg'
import iconAbsorbe from '../../../assets/images/icon-absorbe.svg'
import iconMaxima from '../../../assets/images/icon-maxima.png'
import { textChange } from '../../../constants/activity-constants'
import './benefits.scss'

const Benefits = () => {
  return (
    <div className="f-container-benefits">
      <div id="beneficios" className="f-container-benefits__ancla" />

      <div className="f-container-benefits__content">
        <div className="f-container-benefits__content__top">
          <h2>Beneficios</h2>
          <p>
            ¿Te gustaría tener una buena noche durante tu periodo, sin
            preocuparte por mancharte? Ahora tienes una protección 360º que te
            cubre perfectamente y se mueve contigo mientras duermes, para
            brindarte una máxima protección.
          </p>
        </div>
        <div className="f-container-benefits__content__bot">
          <div className="f-container-benefits__content__bot__card">
            <img src={icon360} alt="icono Sistema de protección 360º" />
            <h3>Sistema de protección 360º</h3>
            <p>
              Se ajusta a tu cuerpo, con elásticos laterales que evitan fugas o
              accidentes
            </p>
          </div>
          <div className="f-container-benefits__content__bot__card">
            <img src={iconRespirable} alt="icono Respirable tipo algodon" />
            <h3>Respirable tipo algodón</h3>
            <p>{textChange.text_3}</p>
          </div>
          <div className="f-container-benefits__content__bot__card">
            <img src={iconNoche} alt="icono para la noche" />
            <h3>Para toda la noche</h3>
            <p>{textChange.text_4}</p>
          </div>
          <div className="f-container-benefits__content__bot__card">
            <img src={iconMaxima} alt="icono maxima protección" />
            <h3>Máxima protección</h3>
            <p>
              {textChange.text_5}
            </p>
          </div>
          <div className="f-container-benefits__content__bot__card">
            <img src={iconAbsorbe} alt="icono absorbe" />
            <h3>Absorbe 30% más</h3>
            <p>Comparada con una toalla Buenas Noches</p>
          </div>
          <div className="f-container-benefits__content__bot__card">
            <img src={iconTallas} alt="icono tallas" />
            <h3>Tallas S, M, L-XL</h3>
            <p>{textChange.text_6}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Benefits
